import React, { Fragment } from "react";
import PropTypes from "prop-types";
//Material imports
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import RatingSystem from "./RatingSystem";
import RateYourExperienceFooter from "./RateYourExperienceFooter";
const CSATFooter = ({
  onClickHandle,
  classes,
  message,
  isTyping
}) => {
  const [localState, setLocalState] = React.useState({
    ratingVisible: message.customerScore !== null ? true : false,
    ratingDisabled: message.customerScore ? true : false
  });
  const {
    ratingVisible,
    ratingDisabled
  } = localState;
  const log = pilog.getLogger("CSATFooter");
  React.useEffect(() => {
    if (isTyping && !ratingDisabled) {
      setLocalState({
        ...localState,
        ratingDisabled: true
      });
      log.debug({
        score: message.customerScore,
        ratingDisabled: true,
        isTyping
      });
    }
  }, [isTyping]);
  const onClick = voteCount => {
    setLocalState({
      ...localState,
      ratingDisabled: true
    });
    onClickHandle(voteCount);
  };
  const renderRatingSystem = () => {
    if (ratingVisible) {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classes.ratingContainer
      }, /*#__PURE__*/React.createElement(RatingSystem, {
        onClick: onClick,
        message: message,
        useDefaultScore: false,
        disabled: ratingDisabled
      })), !isTyping && ratingDisabled && /*#__PURE__*/React.createElement(IconButton, {
        classes: {
          root: `${classes.editButton} ${classes.borderRadius}`
        },
        onClick: () => setLocalState({
          ...localState,
          ratingDisabled: false
        }),
        id: "editRatingButton",
        size: "large"
      }, /*#__PURE__*/React.createElement(EditIcon, null)));
    }
    return /*#__PURE__*/React.createElement(RateYourExperienceFooter, {
      onClick: () => setLocalState({
        ...localState,
        ratingVisible: true
      })
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.csatContainer
  }, renderRatingSystem());
};
const styles = ({
  background
}) => ({
  csatContainer: {
    position: "relative",
    display: "flex",
    flex: "1",
    justifyContent: "space-around",
    alignItems: "center",
    borderTop: "2px solid rgba(0, 0, 0, 0.06)"
  },
  ratingContainer: {
    width: "70%"
  },
  rateExperienceBtn: {
    height: 44
  },
  editButton: {
    height: 44,
    width: 44,
    padding: 8,
    position: "absolute",
    right: 0,
    top: 5,
    "&:hover": {
      backgroundColor: background.default
    }
  },
  borderRadius: {
    borderBottomRightRadius: 12
  }
});
export default withStyles(styles, {
  withTheme: true
})(CSATFooter);
CSATFooter.propTypes = {
  onClickHandle: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  isTyping: PropTypes.bool,
  message: PropTypes.object.isRequired
};